import {useCreateQuestionShuffleJob} from './useCreateQuestionShuffleJob';

/**
 * Hook for shuffling questions in a module
 * This will create a background job to randomize the randomSeed field of questions
 */
export function useShuffleQuestions() {
  const {createQuestionShuffleJob, loading, error} = useCreateQuestionShuffleJob();

  const shuffleQuestions = async (moduleId: string, topics?: string[], difficulties?: number[]) => {
    try {
      const job = await createQuestionShuffleJob(moduleId, topics, difficulties);
      return job;
    } catch (err) {
      console.error('Error creating shuffle job:', err);
      throw err;
    }
  };

  return {
    shuffleQuestions,
    loading,
    error,
  };
}
